import { z } from "zod";

const MAX_ACCRUAL_IMPORT_DOCUMENTS = 500;

const accrualFinancialDocumentIdsSchema = z
    .array(z.number().int().positive())
    .min(1)
    .max(MAX_ACCRUAL_IMPORT_DOCUMENTS);

export const finalizeAccrualImportBodySchema = z.object({
    workspaceId: z.string().uuid(),
    financialDocumentIds: accrualFinancialDocumentIdsSchema,
});

export const confirmAccrualCounterpartiesBodySchema = z.object({
    workspaceId: z.string().uuid(),
    financialDocumentIds: accrualFinancialDocumentIdsSchema,
});

export const confirmAccrualCounterpartiesResponseSchema = z.object({
    confirmedCount: z.number().int().nonnegative(),
});
